import React, { useEffect, useLayoutEffect, useState } from "react"; // Import necessary React hooks
import ReactMarkdown from "react-markdown"; // Import ReactMarkdown for rendering Markdown content
import { usePreview } from "../../../context/PreviewContextProvider";

const Faqs = () => {
  // Destructure context values for campaign and account
  const { account, campaign } = usePreview();

  // State to hold the fetched Markdown content and campaign name
  const [md, setMD] = useState("");

  // Scroll to the top of the page when the component is rendered
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });

  // Function to fetch data from the API
  const getData = async () => {
    // Fetch campaign FAQs based on the wallet address and campaign
    const res = await fetch(`/api/sponsor/${account}/campaign/about/${campaign?.campaign_id}`);
    if (res.status === 200) { // Check if the response is successful
      const json = await res.json(); // Parse the JSON response
      const {
        ct_about_faqs, // Markdown FAQs content
      } = json;

      // Set the fetched Markdown content and campaign name to state
      setMD(ct_about_faqs ? ct_about_faqs : '');
    }
  };

  // Fetch data when account or campaign changes
  useEffect(() => {
    if (account && campaign) getData();
  }, [account, campaign]);

  return (
    <section id="faqs" className="page-settings"> {/* Main container for FAQs section */}
      <h1 className="faqs__title title-styles-nocaptial">
        Questions and Answers about {campaign?.campaign_name || 'NFT'} {/* Dynamic title based on campaign name */}
      </h1>
      <div className="faqs__qas-box">
        <div className="faqs__md">
          {md === "" ? <p>No Faqs yet</p> : <ReactMarkdown>{md}</ReactMarkdown>} {/* Render Markdown or a placeholder if no FAQs */}
        </div>
      </div>
    </section>
  );
};

export default Faqs; // Export the Faqs component for use in other parts of the application
